import { loadOptions } from '../formset.js';

export default function (...args)
{
	return {
		options: [
			{ value: 'eq', label: 'Igual a' },
			{ value: 'ne', label: 'Diferente de' },
			{ value: 'gt', label: 'Maior que' },
			{ value: 'lt', label: 'Menor que' },
			{ value: 'ge', label: 'Maior ou igual a' },
			{ value: 'le', label: 'Menor ou igual a' },
			{ value: 'si', label: 'Similar a' },
			{ value: 'co', label: 'Contém' },
			{ value: 'nc', label: 'Não contém' },
			{ value: 'bw', label: 'Comece com' },
			{ value: 'nb', label: 'Não comece com' },
			{ value: 'ew', label: 'Termine com' },
			{ value: 'nd', label: 'Não termine com' },
			{ value: 'nu', label: 'É nulo' },
			{ value: 'nn', label: 'Não é nulo' },
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		}
	};
}

